module.exports = __webpack_public_path__ + "img/chest-ecto-mesomorph-female.30abf824.svg";